const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
// Authentication
const token = state => 'Bearer ' + state.authentication.authenticationData.token
const isConfirm = state => state.authentication.status ? state.authentication.authenticationData.user.isConfirm : false
const localUser = state => state.authentication.authenticationData.user
const isLoggedIn = state => state.authentication.status
const namespace = state => state.authentication.authenticationData.namespace
const authenticationData = state => state.authentication.authenticationData
// User subscription on local storage
const localUserSubscription = state => state.authentication.authenticationData.subscription
const localCompanySubscription = state => state.authentication.authenticationData.companySubscription
const localUserLimits = state => state.authentication.authenticationData.subscriptionLimits
// Profile
const company = state => state.company.company
const user = state => state.user.user
// Subscriptions
const subscriptions = state => state.subscriptions.subscriptions
const subscription = state => state.subscriptions.subscription
const companySubscription = state => state.subscriptions.companySubscription
// Payments
const payment = state => state.payment.payment
const paymentSuccess = state => state.payment.paymentSuccess
// Invoices
const invoices = state => state.invoices.invoices
const invoice = state => state.invoices.invoice
// Appsettings
const appSettings = state => state.appSettings.appSettings
// location
const locations = state => state.locations.locations
const location = state => state.locations.location
// Countries, timezones and currency
const countries = state => state.countries.countries
const timezones = state => state.countries.timezones
const timezone = state => state.countries.timezone
const addresses = state => state.countries.address
const currentAddress = state => state.countries.currentAddress
const theTimezone = state => state.authentication.authenticationData.timezone
const theCurrency = state => state.authentication.authenticationData.currency
const appTranslations = state => state.appTranslations.appTranslations
// App Configurations
const appConfigurations = state => state.appConfigurations.appConfigurations
const appConfigurationActions = state => state.appConfigurations.appConfigurationActions
const appConfigurationTypes = state => state.appConfigurations.appConfigurationTypes
// App Subscriptions
const appSubscriptions = state => state.appSubscriptions.appSubscriptions
const appSubscriptionPrices = state => state.appSubscriptions.appSubscriptionPrices
const appSubscriptionTypes = state => state.appSubscriptions.appSubscriptionTypes
// System Clients
const appClients = state => state.client.clients
// Errors
const errors = state => state.errors.errors
// Content
const content = state => state.content.content

export {
  config,
  palette,
  isLoading,
  token,
  isLoggedIn,
  countries,
  isConfirm,
  company,
  user,
  localUser,
  subscriptions,
  subscription,
  companySubscription,
  payment,
  invoices,
  invoice,
  paymentSuccess,
  localUserSubscription,
  localUserLimits,
  localCompanySubscription,
  appSettings,
  locations,
  location,
  timezones,
  timezone,
  theTimezone,
  addresses,
  currentAddress,
  appConfigurations,
  appConfigurationActions,
  appConfigurationTypes,
  appSubscriptionPrices,
  appSubscriptions,
  appSubscriptionTypes,
  namespace,
  theCurrency,
  appClients,
  authenticationData,
  errors,
  content,
  appTranslations,
}
